export const teams = [
    {
        'teamID': 1,
        'teamName': 'Indonesia',
        'teamColor': '#FF6358'
    },
    {
        'teamID': 2,
        'teamName': 'New Zealand',
        'teamColor': '#F7C62F'
    },
    {
        'teamID': 3,
        'teamName': 'Malaysia',
        'teamColor': '#55AB1D'
    },
    {
        'teamID': 4,
        'teamName': 'Philippines',
        'teamColor': '#28B4C8'
    }
];